

import { DocumentBase } from "./DocumentBase";
import { Component } from "vue-facing-decorator";

@Component
export class DocumentValidationBase extends DocumentBase {
    //
    // read ocr
    //

    getTokenPoints(token: any) {
        if (
            token &&
            token.boundingPoly &&
            token.boundingPoly.vertices &&
            token.boundingPoly.vertices.length
        ) {
            return token.boundingPoly.vertices.reduce(
                (acc: string, el: { x: number; y: number }) =>
                    `${acc} ${el.x * this.svgScale},${el.y * this.svgScale} `,
                ""
            );
        }
        return "";
    }

    getTokenStyle(token) {
        let style = "cursor:pointer;";
        if (token.selected) {
            style += "fill:rgba(249,177,42,0.5);stroke:#F9B12A;";
            style += token.high ? "stroke-width:3" : "stroke-width:2";
        } else {
            style += "fill:rgba(250,250,250,0.5);stroke:gray;";
            style += token.high ? "stroke-width:3" : "stroke-width:1";
        }
        return style;
    }
}
